export const API_URL = process.env.REACT_APP_API_URL;
export const APP_WS_URL = process.env.REACT_APP_WS_URL;
